import { render, staticRenderFns } from "./ResourcesInvoiceReports.vue?vue&type=template&id=1049d4f1&"
import script from "./ResourcesInvoiceReports.vue?vue&type=script&lang=js&"
export * from "./ResourcesInvoiceReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports